import React from 'react';

import classNames from 'classnames';

interface ButtonWithIconProps {
  label: string;
  icon: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large' | 'extra-large';
  iconPosition?: 'left' | 'right';
  type?: (typeof TYPES)[keyof typeof TYPES];
  className?: string;
  iconClass?: string;
}

const TYPES = {
  primary: 'primary',
  // primary_green: 'primary_green',
  // primary_light: 'primary_light',
  // primary_dark: 'primary_dark',
  // secondary: 'secondary',
  // secondary_green: 'secondary_green',
  tertiary: 'tertiary',
  link: 'link',
  // container: 'container',
  // text_button: 'text_button',
};

export const ButtonWithIcon: React.FC<ButtonWithIconProps> = ({
  label,
  icon,
  onClick,
  disabled = false,
  size = 'medium',
  iconPosition = 'left',
  className = '',
  iconClass = '',
  type = 'primary',
}) => {
  const sizeClasses = {
    small: 'text-[12px] py-2 px-4',
    medium: 'text-[14px] py-2 px-4',
    large: 'text-[16px] py-3 px-6',
    'extra-large': 'text-[20px] py-3 px-8',
  };

  const baseClasses = classNames(
    'inline-flex items-center justify-center items-center rounded-[4px] border transition-colors duration-300 gap-2',
    {
      'border-[#E85EE5] text-[#E85EE5]': !disabled,
      'hover:text-white': !disabled,
      'border-[#424242] text-[#424242] cursor-not-allowed': disabled,
    },
    sizeClasses[size],
    className,
  );

  const buttonTertiaryClass = `${
    disabled
      ? 'border border-gray200 bg-brand-950 text-gray200 hover:cursor-not-allowed'
      : 'bg-gray-900 text-gray-400 border border-gray-900 hover:border-black hover:text-slate-50 active:border-slate-50 active:text-slate-50'
  }`;
  const buttonPrimaryClass = `${
    disabled
      ? 'bg-gray-800 border-gray-800 text-gray-500 hover:cursor-not-allowed'
      : 'bg-brand-400 border-2 border-brand-400 text-brand-950 shadow-[0px_0px_1px_rgba(48,49,51,0.05),0px_4px_8px_rgba(48,49,51,0.1)] outline-none hover:bg-brand-800 hover:border-brand-800 hover:text-white active:bg-brand-500 active:border-brand-500 focus:border-brand-500'
  }`;
  const buttonLinkClass = `${
    disabled
      ? 'bg-transparent  text-brand-700  hover:cursor-not-allowed'
      : 'bg-transparent text-brand-400  outline-none hover:text-brand-500'
  }`;

  const buttonClasses = {
    [TYPES.primary]: `${baseClasses} ${buttonPrimaryClass} `,
    // [TYPES.primary_light]: `${baseClasses} ${buttonPrimaryLightClass}`,
    // [TYPES.primary_dark]: `${baseClasses} ${buttonPrimaryDarkClass}`,
    // [TYPES.secondary]: `${baseClasses} ${buttonSecondaryClass}`,
    [TYPES.tertiary]: `${baseClasses} ${buttonTertiaryClass}`,
    // [TYPES.primary_green]: `${baseClasses} ${buttonPrimaryGreenClass}`,
    // [TYPES.secondary_green]: `${baseClasses} ${buttonSecondaryGreenClass}`,
    // [TYPES.container]: `${baseClasses} ${buttonContainerClass}`,
    // [TYPES.text_button]: `${baseClasses} ${buttonTextClass}`,
    [TYPES.link]: `${baseClasses} ${buttonLinkClass}`,
  };

  const iconClasses = `w-4 h-4 ${iconClass}`;
  const iconWrapperClasses =
    'inline-flex items-center justify-center leading-none [&>svg]:block [&>svg]:shrink-0';
  const labelClasses = 'inline-flex items-center leading-none';

  return (
    <button
      type="button"
      className={buttonClasses[type]}
      onClick={!disabled ? onClick : undefined}
      disabled={disabled}
    >
      {iconPosition === 'left' && (
        <span className={`${iconWrapperClasses} ${iconClasses}`}>{icon}</span>
      )}
      <span className={labelClasses}>{label}</span>
      {iconPosition === 'right' && (
        <span className={`${iconWrapperClasses} ${iconClasses}`}>{icon}</span>
      )}
    </button>
  );
};
